import { computed, inject } from '@angular/core';
import { ColumnState } from 'ag-grid-community';
import { GridPreferencesStore } from './grid-preferences.store';
import { GridId } from './preference-api.types';

/**
 * A functional composable that manages ag-Grid preferences
 * within an injection context (Components, Directives, or Services).
 *
 * It provides reactive access to the saved column states of a specific grid
 * and a method to persist updates back to the global store.
 *
 * @param gridId The unique identifier of the target ag-Grid instance.
 * @returns An object containing the reactive state and update function.
 */
export function injectGridPreferences(gridId: GridId) {
  const store = inject(GridPreferencesStore);
  const gridState = computed(() => store.preferences()[gridId] || null);

  const updateGridState = (states: ColumnState[]) => {
    store.saveGridPreference({ gridId, states });
  };

  return {
    gridState,
    updateGridState,
  };
}
